import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Typography } from "@mui/material";
import AddCoupon from "../../../components/Coupons/AddCoupons";
import CouponModel from "../../../components/Coupons/Model/CouponModel";
import { CoupanCityApi } from "stores/CoupanCitylistStore/CoupanCityApi";

class ConnectorsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coupon_code: "",
      min_amount: "",
      title: "",
      sub_title: "",
      description: "",
      start_date: "",
      expiry_date: "",
      city: "",
      offer: "",
      open: false,
    };
  }

  componentDidMount() {
    this.props.getSlectCouponCityAction();
    this.props.getSelectChargingNetworkAction();
  }

  handleOnChnageCoupon(val) {
    this.setState({ id: val });
    this.props?.SelectCouponCityListdata?.result.map((e) => {
      if (e == val) {
        this.setState({ city: e });
      }
    });

    this.props.getSlectCouponCityAction({ id: val });
  }

  handleOnChnagetypes(val) {
    this.setState({ id: val });
    this.props.getSlectVehicleAction({ id: val });
  }

  submitCityCoupon = async (data) => {
    let res = await CoupanCityApi.postAddCoupanModel(data);

    if (res.status === 1) {
      this.handleClickOpen();
    }
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const Citydata = this.props?.SelectCouponCityListdata?.result;
    const Networkdata = this.props?.SelectChargingNetworkListdata?.result;
    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/coupons"
            >
              Coupons
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              Add Coupon
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <AddCoupon
              onChange={this.handleInputChange}
              handleOnChnageCoupon={(val) => this.handleOnChnageCoupon(val)}
              handleOnChnagetypes={(val) => this.handleOnChnagetypes(val)}
              data={Citydata}
              Networkdata={Networkdata}
              submitCityCoupon={(val) => this.submitCityCoupon(val)}
            />
          </Paper>
          <CouponModel handleClose={this.handleClose} open={this.state.open} />
        </Grid>
      </Grid>
    );
  }
}
export default ConnectorsContainer;
